import { Box } from '@mui/material';
import { keyframes } from '@mui/system';
import { useEffect, useState } from 'react';
import { Img } from '@/components/blocks/MaterialImage';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { useModalOutfitsContext } from '@/components/blocks/ModalOutfits/parts/OutfitsProvider';

const popIn = keyframes`
	from { opacity: 0; transform: scale(0.6); }
	to { opacity: 1; transform: scale(1); }
`;

export const OutfitSelectedThumbnails = () => {
	const { products, productsSelected } = useModalOutfitsContext();
	const [selectionOrder, setSelectionOrder] = useState<string[]>([]);

	// Append newly checked products at the end so the stack follows the selection order
	useEffect(() => {
		setSelectionOrder((prev) => {
			const kept = prev.filter((partNumber) => partNumber in productsSelected);
			const added = products
				.map((product) => product.partNumber)
				.filter((partNumber) => partNumber in productsSelected && !kept.includes(partNumber));
			return [...kept, ...added];
		});
	}, [products, productsSelected]);

	const selectedProducts = selectionOrder
		.filter((partNumber) => partNumber in productsSelected)
		.map((partNumber) => products.find((product) => product.partNumber === partNumber))
		.filter((product): product is NonNullable<typeof product> => product !== undefined);

	return (
		<Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
			{selectedProducts.map((product, index) => (
				<RenderProductImg
					key={product.partNumber}
					fullImageRaw={product.thumbnail}
					render={(img) => (
						<Img
							src={img}
							alt={product.name}
							sx={{
								display: 'block',
								flexShrink: 0,
								width: { xs: '40px', md: '48px' },
								height: { xs: '40px', md: '48px' },
								marginLeft: index === 0 ? 0 : { xs: '-10px', md: '-12px' },
								objectFit: 'cover',
								borderRadius: '50%',
								border: '2px solid #FFFFFF',
								backgroundColor: '#EDEDED',
								boxShadow: '0 2px 6px rgba(0, 0, 0, 0.12)',
								animation: `${popIn} 200ms ease-out`,
							}}
						/>
					)}
				/>
			))}
		</Box>
	);
};
